import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from 'src/app/services/session-service/session.service';

/**
 * Restringe as rotas do Portal Administrativo a usuários com perfil ADMIN.
 * Garante que a sessão esteja populada (o SessionGuard pai também faz isso,
 * mas mantemos a checagem para uso independente/deep-link).
 */
export const adminGuard: CanActivateFn = () => {
  const session = inject(SessionService);
  const router = inject(Router);

  if (!session.user?.perfil) {
    session.setUser();
  }

  if (session.user?.perfil === 'ADMIN') {
    return true;
  }

  return router.parseUrl('/');
};
